import React from 'react'

interface MiniAreaChartProps {
  data?: number[]
  className?: string
}

const buildSmoothPath = (points: Array<{ x: number; y: number }>) => {
  if (points.length < 2) return ''

  let path = `M ${points[0].x} ${points[0].y}`
  for (let i = 1; i < points.length; i += 1) {
    const previous = points[i - 1]
    const current = points[i]
    const midX = (previous.x + current.x) / 2
    const midY = (previous.y + current.y) / 2
    path += ` Q ${previous.x} ${previous.y} ${midX} ${midY}`

    if (i === points.length - 1) {
      path += ` T ${current.x} ${current.y}`
    }
  }

  return path
}

export const MiniAreaChart: React.FC<MiniAreaChartProps> = ({
  data = [4, 8, 34, 54, 56, 50, 60, 66, 74, 82],
  className,
}) => {
  const width = 185
  const height = 124
  const bottom = 114
  const top = 10

  const points = data.map((value, index) => {
    const x = (index / Math.max(1, data.length - 1)) * width
    const y = bottom - (Math.max(0, Math.min(100, value)) / 100) * (bottom - top)
    return { x, y }
  })

  const linePath = buildSmoothPath(points)
  const areaPath = `${linePath} L ${width} ${height} L 0 ${height} Z`

  return (
    <div className={`absolute right-0 top-0 h-[124px] w-[185px] overflow-clip ${className || ''}`}>
      <svg
        className="h-full w-full"
        viewBox="0 0 185 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="fundingAreaFill" x1="92.5" y1="10" x2="92.5" y2="124" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="rgba(200,237,3,0.32)" />
            <stop offset="100%" stopColor="rgba(200,237,3,0)" />
          </linearGradient>
        </defs>

        <path d={areaPath} fill="url(#fundingAreaFill)" />
        <path
          d={linePath}
          stroke="#c8ed03"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default MiniAreaChart
